const animation = {
  "ani_01_title": "<span>糅合藝術、</span><span><em>科學與創新</em></span>",
  "ani_02_title": "<span><em>獨有</em></span><span>LACREON®</span><span>鎖濕科技</span>",
  "ani_03_title": "<span>順滑邊緣設計</span>",
  "ani_04_title": "<span><em>全球No.1眼科視光師信賴</em></span><span>隱形眼鏡品牌^</span>",
  "ani_01_content": "不規則花紋與虹膜自然融合，配戴效果更細緻奪目",
  "ani_02_content": "20小時長效鎖濕*，全日水潤舒適</br>*Data on file, JJVC September 2022.",
  "ani_03_content": "鏡片邊緣更薄、更舒適貼服，減低新手配戴時可能有的異物感，令配戴加倍舒適",
  "ani_04_content": "盡情享受ACUVUE®為你帶來的高品質清晰視力體驗</br>^JJV Data on File 2023. Data Substantiation for ACUVUE Claims Globally_DEC2023",
}

export default animation